import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import BackButton from '../../components/BalanceComponent/BackButton';
import TeacherOlympiadParticipants from '../../components/TeacherOlympiadParticipants';
import FranchOlympiadParticipants from '../../components/FranchOlympiadParticipants';
import './index.css';

export default function OlympiadParticipants() {
    const { t } = useTranslation();
    const { info, emulation } = useSelector(state => state.user);
    const role_id = emulation.length ? emulation[emulation.length - 1].info.role_id : info.role_id;

    return (
        <Fragment>
            <h2 className="container-header">{t('sidebar.olympiad')}</h2>
            <BackButton to="/olympiad" label={t('buttons.back')} />
            {role_id === 3 && <FranchOlympiadParticipants />}
            {role_id === 4 && <TeacherOlympiadParticipants />}
        </Fragment>
    );
}
